// Build a per-user status map keyed by branchId from `/me` payload.
//
// The `/me` endpoint returns the user's per-branch status in the `Status[]`
// array (each entry has `branchId` and `status`). The branch's own status
// (`Branches[].status`) reflects whether the branch itself is active — not
// the user's access. Callers that need to know whether the logged-in user is
// allowed into a given branch should resolve status through this helper.
export function buildUserStatusByBranchId(details) {
  const entries = Array.isArray(details?.Status) ? details.Status : []
  return entries.reduce((acc, entry) => {
    if (entry && entry.branchId != null && entry.status) {
      acc[entry.branchId] = entry.status
    }
    return acc
  }, {})
}

// Merge the per-user status into a branch list. Falls back to the branch's
// own status when no entry exists for that branch, mirroring the fallback
// previously used by the listing pages.
export function mergeUserStatusIntoBranches(branches, userStatusByBranchId) {
  if (!Array.isArray(branches)) return []
  return branches.map((b) => ({
    ...b,
    status: userStatusByBranchId?.[b.id] || b.status || '',
  }))
}

// Convenience: build the merged branch list directly from the `/me` payload.
export function mergeUserStatusFromDetails(details) {
  const branches = Array.isArray(details?.Branches) ? details.Branches : []
  return mergeUserStatusIntoBranches(branches, buildUserStatusByBranchId(details))
}

// True when the user's status for the branch is explicitly set and not
// ACTIVE. Falsy/missing status is treated as active (no info = no block).
export function isBranchInactiveForUser(branch) {
  const status = String(branch?.status || '').toUpperCase()
  return Boolean(status) && status !== 'ACTIVE'
}
